<template>
    <div>
        <b-btn class="btn btn-sm btn-secondary new-user" title="Add New User" v-if="showButton" v-on:click="openUserModel=true">
            <i class="fa fa-plus-circle"></i>
        </b-btn>

        <!-- Modal Component -->
        <b-modal v-model="openUserModel" title="New User" size="lg" ok-title="Create User" ok-variant="success" no-fade @show="getUser" @hide="handleHide" @hidden="handleHidden" @ok="handleOk" ref="userModal" :no-close-on-backdrop="true" scrollable>

            <div v-bind:class="{ 'form-group': true, 'has-error': errors.FirstName }" class="row">
                <label class="col-lg-2 col-md-3 col-sm-4 col-form-label text-sm-right" :class="{'text-danger': errors.FirstName}">
                    First Name: <i class="fa fa-asterisk text-danger"></i>
                </label>
                <div class="col-sm-8">
                    <input type="text" name="FirstName" v-model="user.FirstName" :class="{'form-control': true, 'is-invalid': errors.FirstName}" placeholder="Enter First Number" />
                    <span v-if="errors.FirstName" class="text-danger">
                        <span v-for="error in errors.FirstName">{{ error }}</span>
                    </span>
                </div>
            </div>
            <div v-bind:class="{ 'form-group': true, 'has-error': errors.LastName }" class="row">
                <label class="col-lg-2 col-md-3 col-sm-4 col-form-label text-sm-right" :class="{'text-danger': errors.LastName}">
                    Last Name: <i class="fa fa-asterisk text-danger"></i>
                </label>
                <div class="col-sm-8">
                    <input type="text" name="LastName" v-model="user.LastName" :class="{'form-control': true, 'is-invalid': errors.LastName}" placeholder="Enter Last Name (Required)" />
                    <span v-if="errors.LastName" class="text-danger">
                        <span v-for="error in errors.LastName">{{ error }}</span>
                    </span>
                </div>
            </div>
            <div v-bind:class="{ 'form-group': true, 'has-error': errors.email }" class="row">
                <label class="col-lg-2 col-md-3 col-sm-4 col-form-label text-sm-right" :class="{'text-danger': errors.email}">
                    Email: <i class="fa fa-asterisk text-danger"></i>
                </label>
                <div class="col-sm-8">
                    <input type="text" name="email" v-model="user.email" :class="{'form-control': true, 'is-invalid': errors.email}" placeholder="Enter Email (Required)" />
                    <span v-if="errors.email" class="text-danger">
                        <span v-for="error in errors.email">{{ error }}</span>
                    </span>
                </div>
            </div>
            <div v-bind:class="{ 'form-group': true, 'has-error': errors.timezone_slug }" class="row">
                <label class="col-lg-2 col-md-3 col-sm-4 col-form-label text-sm-right" :class="{'text-danger': errors.timezone_slug}">Timezone: <i class="fa fa-asterisk text-danger"></i></label>
                <div class="col-sm-8">
                    <b-form-select v-model="user.timezone_slug" :options="timezoneOptions" :class="{'is-invalid': errors.timezone_slug}" />

                    <span v-if="errors.timezone_slug" class="text-danger">
                        <span v-for="error in errors.timezone_slug">{{ error }}</span>
                    </span>
                </div>
            </div>
            <div v-bind:class="{ 'form-group': true, 'has-error': errors.title }" class="row">
                <label class="col-lg-2 col-md-3 col-sm-4 col-form-label text-sm-right" :class="{'text-danger': errors.title}">Title:</label>
                <div class="col-sm-8">
                    <input type="text" name="title" v-model="user.title" :class="{'form-control': true, 'is-invalid': errors.title}" placeholder="Enter Title" />
                    <span v-if="errors.title" class="text-danger">
                        <span v-for="error in errors.title">{{ error }}</span>
                    </span>
                </div>
            </div>
            <div v-bind:class="{ 'form-group': true, 'has-error': errors.roles }" class="row">
                <label class="col-lg-2 col-md-3 col-sm-4 col-form-label text-sm-right" :class="{'text-danger': errors.roles}">Assign Roles & Permissions:</label>
                <div class="col-sm-8">
                    <b-form-checkbox-group v-model="selectedRoles" plain>
                        <div v-for="role in roles">
                            <b-form-checkbox :value="role.id">{{ role.name }}</b-form-checkbox>
                        </div>
                    </b-form-checkbox-group>
                </div>
            </div>

        </b-modal>
    </div>
</template>

<script>
    export default {

        props: {
            showButton: {
                type: Boolean,
                default: true,
            },
        },

        data: function() {
            return {
                loading: true,
                user: {},
                openUserModel: false,
                errors: {},
                timezones: [],
                roles: [],
                selectedRoles: [],
                subcontractors: [],
            }
        },

        computed: {
            timezoneOptions(){
                //Setup
                var options = [{value: null, text: '-- Select a Timezone --'}];

                //Loop
                for(var i = 0; i < this.timezones.length; i++)
                {
                    options.push({value: this.timezones[i].zone_slug, text: this.timezones[i].display_name});
                }

                //Send options
                return options;
            },
        },

        methods: {

            show(){
                this.openUserModel = true;
            },

            handleHide(bvEvt){
                //debugging
                if(this.$root.debug)
                {
                    //console.log('Hiding Modal');
                }
            },

            handleHidden(bvEvt){
                //Reset the values
                this.user = {};
                this.errors = {};
            },

            handleOk: function(bvEvt) {

               //Stops the modal from closing
               bvEvt.preventDefault();

               //Show loading?

               //Do it
               this.saveUser();
            },

            getUser(){
                //Send it
                this.$http
                //.get('employees/edit' + (this.employee.EmployeeId ? '/' + this.employee.EmployeeId : ''))
                .get('users/edit')
                .then(response => {
                    //Setter
                    this.user = response.data.user;
                    this.timezones = response.data.timezones;
                    this.roles = response.data.roles;
                    this.selectedRoles = response.data.selectedRoles;
                    this.subcontractors = response.data.subcontractors;

                    //Set some values for the backend
                    this.user.sendEmailInvite = false;
                })
                .catch(error => {

                });
            },

            saveUser() {
                //Reset the errors
                this.errors = {};

                //Set the users roles
                this.user.roles = this.selectedRoles;

                //Send it
                this.$http
                .post('users/edit', this.user)
                .then(response => {
                    //Alert the user?
                    this.$toastr.success('User Saved');

                    //Close the modal
                    this.$refs.userModal.hide();

                    //Return to main list?
                    this.$emit('userCreated', response.data);

                })
                .catch(error => {
                    //Check for error
                    if(error.response.status === 422)
                    {
                        //Display validation errors
                        this.errors = error.response.data
                    }
                    this.$emit('employeeFailed', null);
                })
            },
        },

        mounted() {
            //SEt the height
            //console.log(this.$refs.userModal.$refs);
            //this.$refs.userModal.$refs.body.style['max-height'] = window.innerHeight * 0.75 + 'px';
        }
    }
</script>

<style scoped>
    .new-user {
        position: absolute;
        top: 0;
        right: -28px;
        height: 38px;
    }
</style>